'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../enums/accordion.js');
require('../../../enums/alert.js');
require('../../../enums/avatar.js');
require('../../../enums/breakpoints.js');
require('../../../enums/button.js');
require('../../../enums/code-editor.js');
require('../../../enums/colors.js');
require('../../../enums/combobox.js');
require('../../../enums/date.js');
require('../../../enums/drag-and-drop.js');
require('../../../enums/dialog.js');
require('../../../enums/divider.js');
require('../../../enums/dropdown.js');
require('../../../enums/fieldset.js');
require('../../../enums/font-icon.js');
require('../../../enums/fonts.js');
require('../../../enums/headings.js');
var input$1 = require('../../../enums/input.js');
require('../../../enums/keys.js');
require('../../../enums/list.js');
require('../../../enums/listbox.js');
require('../../../enums/loader.js');
require('../../../enums/margin.js');
require('../../../enums/option.js');
require('../../../enums/pill.js');
require('../../../enums/placements.js');
require('../../../enums/popout.js');
require('../../../enums/privacy.js');
require('../../../enums/radio-group.js');
require('../../../enums/status.js');
require('../../../enums/switch.js');
require('../../../enums/table.js');
require('../../../enums/tooltip.js');
require('../../../enums/transitions.js');
require('../../../enums/widths.js');
require('../../../styles/styled-components/alert.js');
require('../../../styles/styled-components/animations.js');
require('../../../styles/styled-components/box-shadow.js');
require('../../../styles/styled-components/button.js');
require('../../../themes/alert.js');
require('../../../themes/button.js');
require('../../../themes/checkbox.js');
require('../../../themes/divider.js');
require('../../../themes/dropdown.js');
require('../../../themes/fieldset.js');
require('../../../themes/input.js');
require('../../../themes/list.js');
require('../../../themes/listbox.js');
require('../../../themes/loader.js');
require('../../../themes/option.js');
require('../../../themes/popout.js');
require('../../../themes/switch.js');
var themes = require('../../../themes/themes.js');
require('../../../themes/tooltip.js');
require('../../../styles/styled-components/font-face.js');
require('../../../styles/styled-components/global.js');
var input = require('../../../styles/styled-components/input.js');
require('../../../styles/styled-components/list.js');
require('../../../styles/styled-components/listitem.js');
require('../../../styles/styled-components/media-queries.js');
require('../../../styles/styled-components/reset.js');
require('../../../styles/styled-components/outline.js');
require('../../../styles/styled-components/popout.js');
require('../../../styles/styled-components/screen-reader.js');
require('../../../styles/styled-components/switch.js');
require('../../../styles/styled-components/tooltip.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseFakeTextarea = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { className , disabled , error , focused , look , readOnly , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement("div", _extends({}, otherProps, {
        "aria-disabled": disabled,
        "aria-readonly": readOnly,
        className: classnames__default.default({
            'bf-textarea__fake': true,
            'bf-textarea__fake--error': !!error,
            'bf-textarea__fake--disabled': disabled,
            'bf-textarea__fake--focused': focused,
            [`bf-textarea__fake--${look}`]: look,
            'bf-textarea__fake--readonly': readOnly,
            [`${className}`]: !!className
        }),
        ref: ref
    }));
});
const Textarea = styled__default.default(BaseFakeTextarea)`
  ${input.baseInputStyle}
  ${input.getInputBorderRadius({})}
  ${input.getInputPadding({})}
  ${({ error , look  })=>input.getInputTheme({
        error,
        look
    })}
  cursor: ${({ disabled , readOnly  })=>!disabled && !readOnly ? 'pointer' : 'default'};

  &.bf-textarea__fake--focused {
    ${({ disabled , error , look  })=>input.getInputFocusedBorderColor({
        disabled,
        error,
        look
    })}
  }
`;
/**
 * A `<div>` that is styled to look like `<StandardTextarea>` to hold things like `<StandardPill>`.
 *
 * When `InputLabelPositions.Left`is set, it is recommended to set a `width` or `max-width` on `.bf-textfield__header`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
 *
 * @param props FakeTextareaProps
 * @returns FunctionComponent<FakeTextareaProps>
 */ const FakeTextarea = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { look =input$1.InputLooks.Default , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Textarea, _extends({}, otherProps, {
        look: look,
        ref: ref
    })));
});

exports.FakeTextarea = FakeTextarea;
//# sourceMappingURL=fake-textarea.js.map
